import { useSelector } from "react-redux";
import { FeatureResponseDto, OnDataFeature } from "@/gen/api/user";
import { getUserProfile } from "@/reducers/userProfile";


const c_key = 'od_features'

export const useHasFeature = () => {
  return useSelector(store => {
    let features = getUserProfile(store)?.features
    if (features) {
      window.sessionStorage.setItem(c_key, JSON.stringify(features.map(x => ({featureId: x.featureId}))))
    }
    features = features ?? getCachedFeatures()
    const requested = Boolean(features)
    const finalFeatures = features ?? [] as FeatureResponseDto[];
    return {
      requested,
      OnDataDriver: finalFeatures.some(f => f.featureId === OnDataFeature.OnDataDriver),
      OnDataSecureFile: finalFeatures.some(f => f.featureId === OnDataFeature.OnDataSecureFile),
      OnDataSecureDB: finalFeatures.some(f => f.featureId === OnDataFeature.OnDataSecureDB),
      OnDataSecureAI: finalFeatures.some(f => f.featureId === OnDataFeature.OnDataSecureAI),
    }
  })
}

const getCachedFeatures = (): FeatureResponseDto[]|null => {
  try {
    const content = window.sessionStorage.getItem(c_key)
    if (!content) { return null }
    const fs = JSON.parse(content)
    return (fs instanceof Array) ? fs : null
  } catch {
    return null
  }
}